import React from 'react';
import {
  NepPackage3dAddOns,
  NepPackage3dInclude,
  NepPackageCommunityAddOn,
  NepPackageFloorplanAddOns,
  NepPackageFloorplanInclude,
  NepPackagePhotoAddOns,
  NepPackagePhotoInclude,
} from '~/tenants/nep/package/common';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default function NepPackageStandardForm() {
  return (
    <>
      <TenantPackageIncludes>
        <NepPackagePhotoInclude />
        <NepPackageFloorplanInclude />
        <NepPackage3dInclude />
      </TenantPackageIncludes>
      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <NepPackagePhotoAddOns />
        <NepPackageFloorplanAddOns />
        <NepPackage3dAddOns />
        <NepPackageCommunityAddOn />
      </TenantPerformableAddOns>
    </>
  );
}
